<template>
  <div>
      <DesktopRoad></DesktopRoad>
  </div>
</template>

<script>
import DesktopRoad from '@/components/DesktopRoad';

export default {
  components: {
    DesktopRoad,
  },
};
</script>
